export const state = {
  user: {
    loggedIn: false,
    data: {}
  },
  org: {
  }
}

export const getters = {
  user: state => state.user,
  org: state => state.org,
}
